'use strict';

import * as bookingList from '../actions/bookingList';

var allBookings = [];

var defaultState = {
    bookings: [],
    referenceFilter: '',
    stats: {
        totalAmount: 0,
        monthTotal: 0,
        monthChange: null
    },
    delegateToDelete: null,
    isShowingBookingDetails: false,
    bookingToDelete: null,
    bookingToEnroll: null,
    isShowingDeleteOverlay: false,
    isShowingEnrollOverlay: false,
    isRemoveDelegatesChecked: true,
    selectedBooking: null,
    offset: 0,
    limit: 10,
    isEnrollingDelegates: false
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case bookingList.UPDATE_OFFSET:
            return {
                ...state,
                offset: state.offset + state.limit
            };

        case bookingList.RESET_OFFSET:

            return {
                ...state,
                offset: 0
            };

        case bookingList.HIDE_DELETE_DELEGATE_OVERLAY:

            return {
                ...state,
                delegateToDelete: null
            };

        case bookingList.SELECT_DELEGATE_FOR_DELETION:

            return {
                ...state,
                delegateToDelete: action.delegate
            };

        case bookingList.BOOKING_STATS_REFRESHED:

            return {
                ...state,
                stats: action.stats
            };

        case bookingList.TOGGLE_REMOVE_DELEGATES_WITH_BOOKING:

            return {
                ...state,
                isRemoveDelegatesChecked: !state.isRemoveDelegatesChecked
            };

        case bookingList.ENROLLING_DELEGATES_STATUS_UPDATED:

            return {
                ...state,
                isEnrollingDelegates: action.isEnrolling
            };

        case bookingList.HIDE_DELETE_BOOKING_OVERLAY:

            return {
                ...state,
                isShowingDeleteOverlay: false,
                bookingToDelete: null,
                isRemoveDelegatesChecked: true
            };

        case bookingList.HIDE_ENROLL_USER_OVERLAY:

            return {
                ...state,
                isShowingEnrollOverlay: false,
                bookingToEnroll: null,
            };

        case bookingList.SHOW_DELETE_BOOKING_OVERLAY:

            return {
                ...state,
                isShowingDeleteOverlay: true,
                bookingToDelete: action.booking
            };

        case bookingList.SHOW_ENROLL_USER_OVERLAY:

            return {
                ...state,
                isShowingEnrollOverlay: true,
                bookingToEnroll: action.booking
            };

        case bookingList.FILTER_BOOKINGS_BY_REFERENCE:

            return {
                ...state,
                referenceFilter: action.referenceCode,
                offset: defaultState.offset,
                bookings: defaultState.bookings
            };

        case bookingList.HIDE_BOOKING_DETAILS:

            return {
                ...state,
                isShowingBookingDetails: false,
                selectedBooking: null
            };

        case bookingList.SHOW_BOOKING_DETAILS:

            return {
                ...state,
                isShowingBookingDetails: true,
                selectedBooking: action.booking
            };

        case bookingList.BOOKING_UPDATED:

            allBookings = allBookings.map((booking) => {

                if (booking.id === action.booking.id) {

                    booking = {
                        ...booking,
                        ...action.booking
                    };
                }

                return booking;
            });

            return {
                ...state,
                bookings: allBookings
            };

        case bookingList.BOOKINGS_REFRESHED:

            allBookings = action.bookings;

            let selectedBooking = null;

            if (state.selectedBooking) {

                selectedBooking = allBookings.find(b => b.id === state.selectedBooking.id);
            }

            return {
                ...state,
                bookings: action.bookings,
                selectedBooking
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/bookingList.js